import { useQuery } from '@apollo/client';
import { PillGroup } from '@homex/se-react-components';
import { CarouselItemId } from '@homex/se-widget-flow-types';
import { loader } from 'graphql.macro';
import React from 'react';
import { useSelector } from 'react-redux';

import { setSelectedEnergySources } from 'actions';
import { CarouselContinueButton } from 'components/CarouselContinueButton';
import { Phrase } from 'components/Phrase';
import { useThunkDispatch } from 'hooks/useThunkDispatch';
import { IState } from 'typings';
import {
  IEnergyOptionsQuery,
  IEnergyOptionsQueryVariables,
} from 'typings/GraphQL';

import { Buttons, Container, FormGroup, Subhead } from './styles';

const energyOptionsQuery = loader('../../queries/energyOptions.graphql');

export const CarouselItemSystemEnergyBottom = () => {
  const dispatch = useThunkDispatch();
  const { selectedEnergySources } = useSelector((state: IState) => ({
    selectedEnergySources: state.userInput.selectedEnergySources,
  }));

  const { data } = useQuery<IEnergyOptionsQuery, IEnergyOptionsQueryVariables>(
    energyOptionsQuery,
  );

  const energyOptions = data?.energyOptions || [];
  const options = energyOptions.map(({ id, name }) => ({
    key: id,
    label: name,
    value: id,
  }));

  const handleChange = (
    _event: React.FormEvent<HTMLInputElement>,
    value?: string | Array<string>,
  ) => {
    if (Array.isArray(value)) {
      dispatch(setSelectedEnergySources(value));
    }
  };

  return (
    <FormGroup>
      <Container>
        <Subhead>
          <Phrase id="SYSTEM_ENERGY.SUBHEAD" />
        </Subhead>
        <PillGroup
          onChange={handleChange}
          options={options}
          size="small"
          title={Phrase({ id: 'SYSTEM_ENERGY.LEGEND' })}
          titleAlign="left"
          value={selectedEnergySources}
        />
      </Container>
      <Buttons>
        <CarouselContinueButton
          destinationItemId={CarouselItemId.SystemComments}
          isDisabled={selectedEnergySources.length === 0}
        />
      </Buttons>
    </FormGroup>
  );
};
